import conversationCache from 'owa-mail-store/lib//store/conversationCache';
import isItemView from 'mini-mail-list-store/lib/utils/isItemView';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import tryRemoveItemNormalizedBody from 'mini-mail-list-table-operations/lib/actions/table-updates/tryRemoveItemNormalizedBody';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { lazyPrefetchItem } from 'mini-mail-prefetch';

export const clearRowDataUsedByReadingPane = (tableView: TableView): void => {
    if (isItemView(tableView)) {
        for (const itemId of tableView.itemIds) {
            tryRemoveItemNormalizedBody(itemId);
            const mailStore = getMailStore();

            // After we tried to remove normalized body, it might still exist in the cache because it’s held by RP,
            // we need to refresh the item to get refresh data
            if (mailStore.items.get(itemId)?.NormalizedBody) {
                lazyPrefetchItem.importAndExecute(itemId, tableView, true /* updateIfExists */);
            }
        }
    } else {
        // On reloads our cached conversations in the MRU cache would be in a stale state.
        // As we do not keep all the conversations in sync on reloads there are chances
        // that reading pane would show the stale conversation from the MRU cache.
        // We should therefore clear the MRU conversation cache whenever a reload happens.
        conversationCache.clear();

        // The cache might still hold on to the items that are being referenced.
        // In that case we should try to prefetch them.
        // E.g: If user was viewing an item in reading pane when this happened,
        // that item will not be purged (cleared) and we would want to prefetch it.
        const remainingItemsInMRUCache = conversationCache.getItemIds();
        for (let i = 0, len = remainingItemsInMRUCache.length; i < len; i++) {
            lazyPrefetchItem.importAndExecute(
                remainingItemsInMRUCache[i],
                tableView,
                true /* updateIfExists */
            );
        }
    }
};
